import { useLocation, useMatches } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { z } from 'zod'

const initPageTitle = { title: '', description: '' } as const

const PageDetailsSchema = z.object({
  title: z.string(),
  description: z.string().optional(),
})

type PageDetails = z.infer<typeof PageDetailsSchema>

export const usePageDescription = () => {
  const location = useLocation()
  const [_pageDetails, _setPageDetails] = useState<PageDetails>(initPageTitle)
  const [pageDetails, setPageDetails] = useState<PageDetails>(initPageTitle)
  const matches = useMatches()

  // const lastMatchID = matches[matches.length - 1]['appeal_details'] ?? 0
  useEffect(() => {
    const matchesWithPageDetails = matches.filter(
      (match) =>
        z.object({ page_details: PageDetailsSchema }).safeParse(match.handle)
          .success
    )
    if (matchesWithPageDetails.length == 0) {
      _setPageDetails(initPageTitle)
      return
    }

    const lastMatch = matchesWithPageDetails.at(-1)
    const result = z
      .object({ page_details: PageDetailsSchema })
      .safeParse(lastMatch?.handle)
    if (result.success) {
      _setPageDetails(result.data.page_details)
    } else {
      _setPageDetails(initPageTitle)
    }

    return
  }, [location.pathname])

  return {
    pageDetails: pageDetails.title !== '' ? pageDetails : _pageDetails,
    setPageDetails,
  }
}
